module.exports = __webpack_public_path__ + "img/browng.264a4843.jpg";